
import { useSelector } from 'react-redux';

export default function useAuthToken() {
    const authState = useSelector(state => state.auth);
    let user = (authState.data) ? authState.data.user : null;
    return user;
}
